import loader from "@assets/svgs/loader.svg";

const LoadingIndicator = () => {
  return (
    <div className="h-screen inset-0 bg-transparent flex items-center justify-center z-50">
      <div className="relative p-5 rounded-lg">
        <div className="text-center">
          <img src={loader} alt="logo" className="w-24 h-24 animate-spin" />
        </div>
      </div>
    </div>
  );
};

export default LoadingIndicator;
